import { Render } from './render';
import { SETTINGS_DEFAULTS } from '@/node-editor/store';
import { INodeTemplate } from '@/types/node';
import { Edit } from './edit';

const { ALIGNMENT_OPTIONS } = SETTINGS_DEFAULTS;

const template: INodeTemplate = {
  version: 1,
  icon: 'article',
  name: 'Blog Component',
  tag: 'setup & tools',
  type: 'blogcomponent',
  content: {
    imageHeight: 0,
    src: undefined,
    link: {
      target: '_self',
      targetUrl: '',
      targetRel: undefined,
    },
    text: '',
    alignment: {
      vertical: ALIGNMENT_OPTIONS.start,
      horizontal: ALIGNMENT_OPTIONS.start,
    },
    verticalSpacing: {
      top: '0',
      bottom: '0',
    },

    postTitle: '',
    dateTime: '',
  },
  override: {
    postTitle: {},
    dateTime: {},
    image: {},
    root: {},
  },
  supports: {
    contexts: ['page'],
    appender: true,
  },
};

export { template, Edit, Render };
